import styled from 'styled-components'

export const NavWrap = styled.div `
        width:1200px;
        margin:10px auto 10px;
        a{
            color:#00a1b4;
            font-size:18px;
        }
`